import { render } from "./ThreadList.vue?vue&type=template&id=fa104f52"
import script from "./ThreadList.vue?vue&type=script&lang=js"
export * from "./ThreadList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__